// \xa0 (&nbsp;) for cases as 'Utilisateur :', '...oublié ?', '...succès !'
export default Object.freeze({});
